/* eslint-disable no-nested-ternary */
/* eslint-disable no-negated-condition */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import TimeAgo from 'javascript-time-ago';
// Load locale-specific relative date/time formatting rules.
import en from 'javascript-time-ago/locale/en';
import { FormattedMessage } from 'react-intl';
import DateFormatter from 'Common/Components/DateFormatter';
import {
  ColWorkspaceDescription, ColWorkspaceNumeric, ColWorkspaceBetweenTime,
  ColWorkspaceCreated,
  ColScope
} from './styled';
import Name from './Name';
import ImportanceColumn from './ImportanceColumn';
import EnableDisableWs from './EnableDisableWs';
import LockUnlockWs from './LockUnlockWs';
import CheckHeader from './CheckHeader';
import CheckColum from './CheckColumn';
import formatNumber from 'Common/Functions/FormatNumber';
import Description from './Description';
import GroupByPill from './GroupByPill';

TimeAgo.addLocale(en);

/**
 * Workspaces table.
 * ctx: `{ isFetching, setShowConfirmation, fields, theme }`
 *
 * Widths/visibility/order come from `fields` WITHOUT optional chaining (as the legacy columns
 * did): a missing field throws the same way. `group_by` keeps its hard-coded fallbacks.
 */
const workspacesSchema = {
  id: 'workspaces',
  loading: { mockRows: 13, skeleton: ({ isFetching }) => isFetching },
  ordering: {},
  columns: [{
    header: () => <CheckHeader />,
    id: 'selected',
    accessor: 'Selected',
    sortable: false,
    resizable: false,
    maxWidth: 38,
    minWidth: 38,
    style: { display: 'flex' },
    cell: (rowInfo) => <CheckColum ws={ rowInfo.original } />
  },
  {
    header: () => <FormattedMessage id="workspaces.table.columns.importance" />,
    id: 'importance',
    accessor: 'importance',
    maxWidth: ({ fields }) => fields.importance.maxWidth,
    minWidth: ({ fields }) => fields.importance.minWidth,
    width: ({ fields }) => fields.importance.defaultMin,
    visible: ({ fields }) => fields.importance.visible,
    order: ({ fields }) => fields.importance.order,
    resizable: true,
    cell: (rowInfo) => <ImportanceColumn ws={ rowInfo.original } />
  },
  {
    header: () => <FormattedMessage id="workspaces.table.columns.workspace" />,
    id: 'name',
    accessor: 'name',
    resizable: true,
    maxWidth: ({ fields }) => fields.name.maxWidth,
    minWidth: ({ fields }) => fields.name.minWidth,
    width: ({ fields }) => fields.name.defaultMin,
    visible: ({ fields }) => fields.name.visible,
    order: ({ fields }) => fields.name.order,
    cell: (rowInfo, { isFetching }) => <Name isFetching={ isFetching } ws={ rowInfo.original } />,
    skeleton: false,
    cellProps: () => ({ 'column-type': 'name' })
  },
  {
    header: () => <FormattedMessage id="workspaces.table.columns.groupedBy" defaultMessage="Grouped By" />,
    id: 'group_by',
    accessor: 'group_by',
    resizable: true,

    maxWidth: ({ fields }) => fields.group_by?.maxWidth ?? 140,
    minWidth: ({ fields }) => fields.group_by?.minWidth ?? 120,
    width: ({ fields }) => fields.group_by?.defaultMin ?? 130,
    visible: ({ fields }) => fields.group_by?.visible ?? true,
    order: ({ fields }) => fields.group_by?.order ?? 0,

    sortable: false,
    cell: (rowInfo) => <GroupByPill ws={ rowInfo.original } />,
    cellProps: () => ({ 'column-type': 'group_by' })
  },
  {
    header: () => <FormattedMessage id="workspaces.table.columns.description" />,
    id: 'description',
    accessor: 'description',
    sortable: false,
    maxWidth: ({ fields }) => fields.description.maxWidth,
    minWidth: ({ fields }) => fields.description.minWidth,
    width: ({ fields }) => fields.description.defaultMin,
    visible: ({ fields }) => fields.description.visible,
    order: ({ fields }) => fields.description.order,
    resizable: true,
    cell: (rowInfo) => <Description ws={ rowInfo.original } />,
    cellProps: () => ({ 'column-type': 'description' })
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.created.context" />,
    resizable: true,
    id: 'create_date',
    accessor: 'create_date',
    maxWidth: ({ fields }) => fields.create_date.maxWidth,
    minWidth: ({ fields }) => fields.create_date.minWidth,
    width: ({ fields }) => fields.create_date.defaultMin,
    visible: ({ fields }) => fields.create_date.visible,
    order: ({ fields }) => fields.create_date.order,
    cell: (rowInfo) => <ColWorkspaceCreated><DateFormatter date={ rowInfo.original.create_date } /></ColWorkspaceCreated>
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.scope" />,
    resizable: true,
    sortable: false,
    id: 'scope',
    accessor: 'scope',
    maxWidth: ({ fields }) => fields.scope.maxWidth,
    minWidth: ({ fields }) => fields.scope.minWidth,
    width: ({ fields }) => fields.scope.defaultMin,
    visible: ({ fields }) => fields.scope.visible,
    order: ({ fields }) => fields.scope.order,
    cell: (rowInfo) => (
      <ColScope active={ rowInfo.original.active } title={ rowInfo.original.scope?.map((el) => el.name || el)?.join(', ') }>
        { rowInfo.original.scope?.map((el) => el.name || el)?.join(', ') }
      </ColScope>
    )
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.customer" />,
    resizable: true,
    id: 'customer',
    accessor: 'customer',
    maxWidth: ({ fields }) => fields.customer.maxWidth,
    minWidth: ({ fields }) => fields.customer.minWidth,
    width: ({ fields }) => fields.customer.defaultMin,
    visible: ({ fields }) => fields.customer.visible,
    order: ({ fields }) => fields.customer.order,
    cell: (rowInfo) => (
      <ColWorkspaceDescription active={ rowInfo.original.active }>
        { rowInfo.original.customer }
      </ColWorkspaceDescription>
    )
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.vulnerabilidades" />,
    resizable: true,
    id: 'vulnerabilities',
    accessor: 'vulnerabilities',
    maxWidth: ({ fields }) => fields.vulnerabilities.maxWidth,
    minWidth: ({ fields }) => fields.vulnerabilities.minWidth,
    width: ({ fields }) => fields.vulnerabilities.defaultMin,
    visible: ({ fields }) => fields.vulnerabilities.visible,
    order: ({ fields }) => fields.vulnerabilities.order,
    cell: (rowInfo) => (
      <ColWorkspaceNumeric active={ rowInfo.original.active } title={ rowInfo.original.stats.total_vulns }>
        { formatNumber(rowInfo.original.stats.total_vulns) }
      </ColWorkspaceNumeric>
    ),
    cellProps: () => ({ 'column-type': 'vulnerabilities' }),
    sortable: false
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.assets" />,
    resizable: true,
    id: 'hosts',
    accessor: 'hosts',
    sortable: false,
    maxWidth: ({ fields }) => fields.hosts.maxWidth,
    minWidth: ({ fields }) => fields.hosts.minWidth,
    width: ({ fields }) => fields.hosts.defaultMin,
    visible: ({ fields }) => fields.hosts.visible,
    order: ({ fields }) => fields.hosts.order,
    cell: (rowInfo) => (
      <ColWorkspaceNumeric active={ rowInfo.original.active } title={ rowInfo.original.stats.hosts }>
        { formatNumber(rowInfo.original.stats.hosts) }
      </ColWorkspaceNumeric>
    ),
    cellProps: () => ({ 'column-type': 'hosts' })
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.services" />,
    resizable: true,
    id: 'services',
    accessor: 'services',
    sortable: false,
    maxWidth: ({ fields }) => fields.services.maxWidth,
    minWidth: ({ fields }) => fields.services.minWidth,
    width: ({ fields }) => fields.services.defaultMin,
    visible: ({ fields }) => fields.services.visible,
    order: ({ fields }) => fields.services.order,
    cell: (rowInfo) => (
      <ColWorkspaceNumeric active={ rowInfo.original.active } title={ rowInfo.original.stats.services }>
        { formatNumber(rowInfo.original.stats.services) }
      </ColWorkspaceNumeric>
    ),
    cellProps: () => ({ 'column-type': 'services' })
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.datesBetween.context" />,
    resizable: true,
    id: 'range_dates',
    accessor: 'range_dates',
    sortable: false,
    maxWidth: ({ fields }) => fields.range_dates.maxWidth,
    minWidth: ({ fields }) => fields.range_dates.minWidth,
    width: ({ fields }) => fields.range_dates.defaultMin,
    visible: ({ fields }) => fields.range_dates.visible,
    order: ({ fields }) => fields.range_dates.order,
    cell: (rowInfo) => (
      <ColWorkspaceBetweenTime>
        {`${rowInfo.original.duration.start_date ? new Date(rowInfo.original.duration.start_date).toString().substring(0, 15) : ''}${rowInfo.original.duration.start_date && rowInfo.original.duration.end_date ? ' - ' : ''}${rowInfo.original.duration.end_date ? new Date(rowInfo.original.duration.end_date).toString().substring(0, 15) : ''}`}
      </ColWorkspaceBetweenTime>
    ),
    cellProps: () => ({ 'column-type': 'range_dates' })
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.lastModified" />,
    id: 'update_date',
    accessor: 'update_date',
    resizable: true,
    maxWidth: ({ fields }) => fields.update_date.maxWidth,
    minWidth: ({ fields }) => fields.update_date.minWidth,
    width: ({ fields }) => fields.update_date.defaultMin,
    visible: ({ fields }) => fields.update_date.visible,
    order: ({ fields }) => fields.update_date.order,
    cell: (rowInfo) => {
      const date = new Date(rowInfo.original.update_date);
      const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
      return <div>{formattedDate}</div>;
    },
    cellProps: (rowInfo, { theme }) => ({ 'column-type': 'update_date', 'style': { color: theme.themeStyles.text.tableVulnName } })
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.permissions" />,
    id: 'readonly',
    accessor: 'readonly',
    filterable: false,
    cell: (rowInfo, { isFetching }) => <LockUnlockWs isFetching={ isFetching } ws={ rowInfo.original } />,
    skeleton: false,
    resizable: true,
    maxWidth: ({ fields }) => fields.readonly.maxWidth,
    minWidth: ({ fields }) => fields.readonly.minWidth,
    width: ({ fields }) => fields.readonly.defaultMin,
    visible: ({ fields }) => fields.readonly.visible,
    order: ({ fields }) => fields.readonly.order,
    cellProps: (rowInfo, { theme }) => ({ 'column-type': 'readonly', 'style': { color: theme.themeStyles.text.tableVulnName } })
  }, {
    header: () => <FormattedMessage id="workspaces.table.columns.status" />,
    accessor: 'active',
    maxWidth: ({ fields }) => fields.active.maxWidth,
    minWidth: ({ fields }) => fields.active.minWidth,
    width: ({ fields }) => fields.active.defaultMin,
    visible: ({ fields }) => fields.active.visible,
    order: ({ fields }) => fields.active.order,
    resizable: true,
    filterable: false,
    id: 'active',
    cell: (rowInfo, { isFetching, setShowConfirmation }) => <EnableDisableWs isFetching={ isFetching } ws={ rowInfo.original } setShowConfirmation={ setShowConfirmation } />,
    skeleton: false,
    cellProps: () => ({ 'column-type': 'active' })
  }
  ]
};

export default workspacesSchema;
